import React from "react";
import { useGetOrderCompletionPercentageQuery } from "../../features/home/homeApi";
import { percentage } from "../../helpers/utils/Utils";

export const AutoCompletionStats = () => {
  const { data: completion } = useGetOrderCompletionPercentageQuery("");

  const gaugeData = [
    { label: "Tax Certs", value: percentage(completion?.originalTaxCertAutoCompletes, completion?.originalTaxCertOrders) },
    { label: "Tax Certs (Updates)", value: percentage(completion?.reOrderedTaxCertAutoCompletes, completion?.reOrderedTaxCertOrders) },
    { label: "HOA Certs", value: percentage(completion?.originalHoaAutoCompletes, completion?.originalHoaOrders) },
    { label: "HOA Certs (Updates)", value: percentage(completion?.reOrderedHoaAutoCompletes, completion?.reOrderedHoaOrders) }
  ];


  return (
    <div className="p-4 relative;">
      <h6 className="absolute text-[20px] bg-text-0 px-[20px] py-0">Auto Complete Stats</h6>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-5 t-5 rounded-[6px] mt-[17px] pt-[50px] pb-[30px] bg-text-0 shadow-[0_0_5px_rgba(0,0,0,0.2)] border-none">
        {gaugeData.map((item, index) => (
          <div key={index} className="flex flex-col items-center ">
            <svg width="250" height="125" viewBox="0 0 100 50">
              {/* Background Arc */}
              <path d="M 10,50 A 40,40 0 0,1 90,50" fill="none" stroke="#D3D3D3" strokeWidth="6" />

              {/* Progress Arc */}
              <path
                d="M 10,50 A 40,40 0 0,1 90,50"
                fill="none"
                stroke={item.value > 0 ? "#00BFFF" : "#D3D3D3"}
                strokeWidth="6"
                strokeLinecap="round"
                strokeDasharray={`${(item.value / 100) * 125.66}, ${125.66 - (item.value / 100) * 125.66}`}
              />
            </svg>
            <div className={"-mt-14 text-center"}>
              <div className="text-3xl font-bold ">{item?.value?.toFixed(2)}%</div>
              <h5 className="text-2xl text-text-7 font-medium text-center w-[120px]">{item.label}</h5></div>
          </div>
        ))}
      </div>
    </div>

  );
};
